if (!window.CM) window.CM = {};
const CM = window.CM;
if (!CM.tool) CM.tool = {};
if (!CM.tool.page) CM.tool.page = {};

if (!CM.tool.page.notification) {
    CM.tool.page.notification = {
        timeAgoTimeout: null,
        checkTimeout: null,
        initialize: function () {
            $('.dropdown-notifications-trigger').on('click', function (event) {
                $(this).toggleClass('open').parent().toggleClass('open');
            });

            $('.dropdown-notifications-trigger-fixed').on('click', function (event) {
                event.preventDefault();
                $(this).toggleClass('open');
                $('#user-notifications-panel-fixed').show().addClass('open');
            });

            $('body').on('click', function (e) {
                if (
                    !$('.dropdown-notifications').is(e.target) &
                        !$('.dropdown-notifications-trigger-fixed').is(e.target) &&
                    $('.dropdown-notifications').has(e.target).length === 0 &&
                    $('.open').has(e.target).length === 0
                ) {
                    $('.dropdown-notifications').removeClass('open');
                    $('.dropdown-notifications-trigger-fixed').removeClass('open');
                    $('#user-notifications-panel-fixed').hide();
                }
            });

            $('.dropdown-toolbar-actions a').on('click', function (event) {
                event.preventDefault();
                $('.notification button').trigger('click');
            });

            if (window.location.pathname.substr(0, 6) == '/tool/') {
                CM.tool.page.notification.check();
            }
        },
        check: function () {
            clearTimeout(CM.tool.page.notification.checkTimeout);
            $.ajax({
                type: 'GET',
                url: '/global/endpoints/user-notifications/?f=gn',
                success: function (data) {
                    if (data && data.success) {
                        $('.dropdown-notifications').removeClass('transparent');
                        $('.user-notifications-list').empty();
                        $('.dropdown-toolbar-title span').html(data.count);
                        $('.notification-icon').attr('data-count', data.count);
                        if (data.count > 0) {
                            $('.notification-icon').removeClass('badge-hidden');
                            $('.dropdown-toolbar-actions').show();
                            $('.user-notifications-panel .dropdown-footer').hide();

                            jQuery.each(data.notifications, function (index, notification) {
                                CM.tool.page.notification.buildNotification(notification);
                            });

                            $('.user-notifications-list .notification').on('close.bs.alert', function () {
                                CM.tool.page.notification.dismiss($(this).data('id'));
                            });

                            CM.tool.page.notification.updateTimeAgo();
                        } else {
                            $('.notification-icon').addClass('badge-hidden');
                            $('.dropdown-toolbar-actions').hide();
                            $('.user-notifications-panel .dropdown-footer').show();
                        }
                        CM.tool.page.notification.checkTimeout = setTimeout(CM.tool.page.notification.check, 30000);
                    }
                },
            });
        },
        dismiss: function (notificationId) {
            $.ajax({
                type: 'GET',
                url: '/global/endpoints/user-notifications/?f=dn&n=' + notificationId,
                success: function (data) {
                    if (data.success) {
                        var count = $('.dropdown-notifications .notification-icon').attr('data-count') - 1;
                        $('.notification-icon').attr('data-count', count);
                        $('.dropdown-toolbar-title span').html(count);
                        if (count == 0) {
                            $('.notification-icon').addClass('badge-hidden');
                            $('.dropdown-toolbar-actions').hide();
                            $('.user-notifications-panel .dropdown-footer').show();
                        }
                    }
                },
            });
        },
        buildNotification: function (notification, speed) {
            var dtDateSent = new Date(notification.d);
            var sDateTime = moment(dtDateSent).format('LLLL');

            var html =
                '<li class="notification alert fade in" data-id="%1" style="display:none"><button type="button" class="close" data-dismiss="alert" style="float:right;"><span aria-hidden="true">&times;</span></button>' +
                '<h3>%2</h3><p>%3</p>' +
                '<div class="notification-meta"><span class="timeago" data-time="%4" title="%5"></span></div></li>';
            html = html.replace('%1', notification.id);
            html = html.replace('%2', notification.t);
            html = html.replace('%3', notification.c);
            html = html.replace('%4', dtDateSent.toISOString());
            html = html.replace('%5', sDateTime);

            $('.user-notifications-list').each(function () {
                $(html).prependTo(this).show();
            });
            //$(html).prependTo('.user-notifications-list').show();
        },
        updateTimeAgo: function () {
            clearTimeout(CM.tool.page.notification.timeAgoTimeout);

            $('.timeago').each(function () {
                var elem = $(this);
                var value = elem.data('time');
                elem.html(moment(value).fromNow());
            });
            CM.tool.page.notification.timeAgoTimeout = setTimeout(CM.tool.page.notification.updateTimeAgo, 60000);
        },
    };

    $(document).ready(function () {
        CM.tool.page.notification.initialize();
    });
}
